import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import TableFooter from "@/components/table/footer";
import TablePagination from "@/components/table/pagination";
import { exportToCSV } from "@/utils/export-to-csv";
import { Box } from "rizzui";
import { serviceListColumns } from "./columns";
import { Notification } from "@/types"; // Update import to Notification type
import { useEffect } from "react";

type NotificationListTableProps = {
    notifications: Notification[]; // Change to Notification array
    refresh(): void;
};

export default function NotificationListTable({ notifications = [], refresh }: NotificationListTableProps) { // Default to empty array
    const { table, setData } = useTanStackTable<Notification>({
        tableData: notifications, // Use notifications array directly
        columnConfig: serviceListColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 10,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                    table.resetRowSelection();
                },
                handleMultipleDelete: (rows) => {
                    setData((prev) => prev.filter((r) => !rows.includes(r)));
                    table.resetRowSelection();
                },
            },
            enableColumnResizing: false,
        },
    });

    useEffect(() => {
        setData(notifications); // Use notifications array directly
    }, [notifications, setData]);

    const selectedData = table
        .getSelectedRowModel()
        .rows.map((row) => row.original);

    function handleExportData() {
        exportToCSV(
            selectedData,
            "Id,Title,NotificationType,Email,PhoneNumber,WhatsApp,Message,SentDate,SentBy", // Update CSV headers
            `Notifications_${selectedData.length}`, // Update file name prefix
        );
    }

    return (
        <Box>
            <Table
                table={table}
                variant="modern"
                classNames={{
                    container: "border border-muted rounded-md",
                    rowClassName: "last:border-0",
                }}
            />
            <TableFooter table={table} onExport={handleExportData} />
            <TablePagination table={table} className="py-4" />
        </Box>
    );
}
